import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/authContext';
import '../styles/UserButtons.css';

const UserButtons = () => {
    const { user, logout } = useAuth();

    const handleLogout = async () => {
        try {
            await logout();
        } catch (error) {
            console.error('Error logging out:', error);
        }
    };

    if (!user) {
        return null;
    }

    return (
        <div className="user-buttons">
            <Link to={`/profile/${user.uid}`} className="username">
                {user.displayName || 'User'}
            </Link>
            <button onClick={handleLogout} className="logout-button">
                Logout
            </button>
        </div>
    );
};

export default UserButtons; 